import {
  anAddInsightCommentsById,
  anUpdateInsightsById,
  mockUpdateInsightsByIdOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const updateInsightsByIdOperationData = {
  __typename: 'Mutation' as const,
  addInsightCommentsById: anAddInsightCommentsById(),
  updateInsightsById: anUpdateInsightsById(),
};

export const handlers = [
  mockUpdateInsightsByIdOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: updateInsightsByIdOperationData,
      });
    }
  ),
];
